module.exports = __webpack_public_path__ + "static/img/haoping.9cc713c4.jpeg";